import axiosInstance from "./axiosConfig";
import { getUser } from "./authService";
const user = getUser();
export interface User {
  id: number;
  name: string;
  email: string;
  role: string; // Display as string
  roleId?: number; // Send as number
  password?: string;
  companyId?: number;
  company?: string;
}

export interface Company {
  id: number;
  name: string;
}

export const getUsers = async () => {
  try {
    const user = getUser();
    console.log(user,user.company.id)
    const response = await axiosInstance.get<User[]>("/users/?companyid=" +user.company.id);
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch users");
  }
};

export const getCompanies = async () => {
  try {
    const response = await axiosInstance.get<Company[]>("/companies");
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch companies");
  }
};

export const addUser = async (userData: Partial<User>) => {
  try {
    console.log("the data ",userData);
    const response = await axiosInstance.post<User>("/users", userData);
    return response.data;
  } catch (error) {
    throw new Error("Failed to add user");
  }
};

export const updateUser = async (id: number, userData: Partial<User>) => {
  try {
    console.log('test',userData);
    userData.companyId =0
    const response = await axiosInstance.put<User>(`/users/${id}`, userData);
    return response.data;
  } catch (error) {
    throw new Error("Failed to update user");
  }
};

export const deleteUser = async (id: number) => {
  try {
    await axiosInstance.delete(`/users/${id}`);
  } catch (error) {
    throw new Error("Failed to delete user");
  }
};
